<button type="button" (click)="open()">
      <span>Adicionar ao Carrinho</span> 
</button>      
